import { render, staticRenderFns } from "./DetailRemoteRequest.vue?vue&type=template&id=4f0911f4&scoped=true&"
import script from "./DetailRemoteRequest.vue?vue&type=script&lang=js&"
export * from "./DetailRemoteRequest.vue?vue&type=script&lang=js&"
import style0 from "./DetailRemoteRequest.vue?vue&type=style&index=0&id=4f0911f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0911f4",
  null
  
)

export default component.exports